
export const headerData = {
    name: 'Miretu Jaleta',
    title: "Hello! I am",
    role: 'Senior Software Engineer',
    company: 'Ethiopian Artificial Intelligence Institute',
    intro: "I build full-stack web applications, microservices and computer vision systems. At the Ethiopian Artificial Intelligence Institute in Addis Ababa, I work mostly on full-stack products, alongside machine learning and computer vision.",
    timezone: 'Africa/Addis_Ababa',
    languages: 'Afan Oromo (native), Amharic and English (fluent)',
    experience: '6 years',
    coreStack: ['Python', 'Django REST Framework', 'React.js', 'Next.js', 'Node.js', 'PostgreSQL'],
    image: '/profile-v2.webp',
    imageSmall: '/profile-v2-320.webp',
    imageFallback: '/profile-v2.jpg',
    imageAlt: 'Portrait of Miretu Jaleta',
    resumePdf: 'https://drive.google.com/file/d/1hEh9FMKIUU3BHLjUQ-uSIN_F0iCkAt5G/view?usp=sharing'
}
